<template>
  <div class="home">
    <img alt="Vue logo" src="../../assets/logo.png" />
    <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World <br />
    Hello World
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
};
</script>
